import React from 'react'

import MenuItem from "./item"
import NewField from "./new-field"
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {PopoverAddColumnProps} from "../popover"

type Props = {
    section             : string
    addedColumnsIds?    : ID[]

    onSelectSection     : func
} & PopoverAddColumnProps

export default class Menu extends React.Component<Props> {

    render() {

        const noValueGroup = this.props.noValueOption ? {
            groupId     : 'none',
            groupName   : this.props.noValueOption.label,
            fields      : []
        } : null

        return (
            <VScroll className="menu" containerClass="ui5-menu">
                {noValueGroup &&
                    <>
                        <MenuItem group             = {noValueGroup}
                                  onSelectSection   = {this.props.onSelectSection}/>
                        <div className="separator-h"/>
                    </>}

                {_.map(this.props.manageColumnsConfig, group=>{
                    if (group.groupType === 'custom-fields' || group.fields.length !== 0)
                        return <MenuItem key                = {group.groupId}
                                         group              = {group}
                                         addedColumnsIds    = {this.props.addedColumnsIds}
                                         selected           = {group.groupId === this.props.section}
                                         onSelectSection    = {this.props.onSelectSection}/>
                })}

                {this.props.showAdd &&
                    <NewField selected          = {'new-field' === this.props.section}
                              onSelectSection   = {this.props.onSelectSection}/>}
            </VScroll>
        )
    }
}